module.exports = __webpack_public_path__ + "img/website-store-tiles-01-5_low_print-box.df3d9404.jpeg";